//@ts-nocheck
import React from "react";
import MDBox from "components/MDBox";
import MDInput from "components/MDInput";
import MDTypography from "components/MDTypography";
import MDEditor from "components/MDEditor";
import { autoDiscover } from "dropzone";
import JoditEmailEditor from "./JoditEmailEditor";

interface EmailPreviewComponentProps {
  htmlContent: any;
  emailBody: any;
  setEmailBody: (data: any) => void;
  updateStoreEmailContent: (data: any) => void;
}

const EmailPreviewComponent: React.FC<EmailPreviewComponentProps> = ({
  htmlContent,
  emailBody,
  setEmailBody,
  updateStoreEmailContent,
}) => {
  return (
    <MDBox>
      <MDBox display={"flex"} gap={1} alignItems={"center"}>
        <MDTypography>Subject:</MDTypography>
        <MDInput
          style={{ width: "80%", marginLeft: "8px" }}
          type="text"
          value={emailBody?.subject}
          onChange={(e: any) => {
            setEmailBody({ ...emailBody, subject: e.target.value });
          }}
          placeholder="Subject"
        />
      </MDBox>

      <MDBox style={{ marginTop: "20px" }} maxHeight={700} overflow={"auto"}>
        <JoditEmailEditor
          initialHtml={htmlContent}
          updateEmailContent={updateStoreEmailContent}
          templateName={emailBody?.templateName}
        />
      </MDBox>
    </MDBox>
  );
};

export default EmailPreviewComponent;
